import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './InfoIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const InfoIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function InfoIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 22 22" component={Icon} {...props} />
  );
});
